export const UPDATE_COMMENT_BY_TARGET_ACTUAL_REQUEST = 'UPDATE_COMMENT_BY_TARGET_ACTUAL_REQUEST';

export const updateCommentByTargetActualRequest = ( id, updateData ) => ({
    type: UPDATE_COMMENT_BY_TARGET_ACTUAL_REQUEST,
    payload: {
        id,
        updateData
    }
});
